define('home/templates/activityCardPost',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {};

  return container.escapeExpression(helpers.gettext.call(alias1,"%(group)s commented %(numOccurance)s times",{"name":"gettext","hash":{"numOccurance":(depth0 != null ? depth0.numOccurance : depth0),"group":helpers.getPartial.call(alias1,"userGroup",{"name":"getPartial","hash":{},"data":data})},"data":data}))
    + "\n";
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {};

  return container.escapeExpression(helpers.gettext.call(alias1,"%(group)s commented",{"name":"gettext","hash":{"group":helpers.getPartial.call(alias1,"userGroup",{"name":"getPartial","hash":{},"data":data})},"data":data}))
    + "\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "<div class=\"expandable\">\n<div class=\"card-grouped-actions\">\n<a href=\"#\" data-action=\"toggle-collapsed\" class=\"expandable card-expand\">\n<div class=\"icon-more-vert\"></div>\n"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"See More",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</div>\n</div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression;

  return "<div class=\"collapsible\">\n<div class=\"card-grouped-actions\">\n<a class=\"collapsible button button-outline button-small\" href=\""
    + alias1(container.lambda((depth0 != null ? depth0.discussionRoute : depth0), depth0))
    + "\" data-link-name=\"view_comment\">\n"
    + alias1(helpers.gettext.call(depth0 != null ? depth0 : {},"See All Comments",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</div>\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "<div class=\"card-reason\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.numOccurances : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "<span class=\"time\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.relativeTime : depth0), depth0))
    + "</span>\n</div>\n"
    + ((stack1 = container.invokePartial(partials.cardTitle,depth0,{"name":"cardTitle","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<div data-role=\"posts\"></div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.shouldCollapse : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hasOverflowPosts : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<footer class=\"card-footer\" data-role=\"footer\"></div>\n";
},"usePartial":true,"useData":true})

});
